import StateMachine from 'javascript-state-machine';

import { STATUS_PROGRAM } from './status-program';
import { TRANSITION_PROGRAM } from './transition-program';

const transitionsByType = {
  assigned: [
    {
      name: TRANSITION_PROGRAM.TRANSITION_PROGRAM_ACCEPT, // accept
      from: STATUS_PROGRAM.STATUS_PROGRAM_PENDING,
      to: STATUS_PROGRAM.STATUS_PROGRAM_ACCEPTED,
    },
    {
      name: TRANSITION_PROGRAM.TRANSITION_PROGRAM_MARK_AS_READY, // mark as ready
      from: STATUS_PROGRAM.STATUS_PROGRAM_ACCEPTED,
      to: STATUS_PROGRAM.STATUS_PROGRAM_READY,
    },
    { name: TRANSITION_PROGRAM.TRANSITION_PROGRAM_ACTIVATE, // activate
      from: STATUS_PROGRAM.STATUS_PROGRAM_DRAFT,
      to: STATUS_PROGRAM.STATUS_PROGRAM_ACTIVE,
    },
    { name: TRANSITION_PROGRAM.TRANSITION_PROGRAM_ACTIVATE_SEND_NOTIFICATION, // resend email
      from: [STATUS_PROGRAM.STATUS_PROGRAM_ACTIVE, STATUS_PROGRAM.STATUS_PROGRAM_CURRENT],
      to: STATUS_PROGRAM.STATUS_PROGRAM_ACTIVE,
    },
    {
      name: TRANSITION_PROGRAM.TRANSITION_PROGRAM_PUT_ON_HOLD, // put on hold
      from: [STATUS_PROGRAM.STATUS_PROGRAM_ACTIVE, STATUS_PROGRAM.STATUS_PROGRAM_CURRENT],
      to: STATUS_PROGRAM.STATUS_PROGRAM_ON_HOLD,
    },
    {
      name: TRANSITION_PROGRAM.TRANSITION_PROGRAM_REACTIVATE, // reactivate
      from: STATUS_PROGRAM.STATUS_PROGRAM_ON_HOLD,
      to: STATUS_PROGRAM.STATUS_PROGRAM_ACTIVE,
    },
    {
      name: TRANSITION_PROGRAM.TRANSITION_PROGRAM_CANCEL, // cancel
      from: [STATUS_PROGRAM.STATUS_PROGRAM_ACTIVE, STATUS_PROGRAM.STATUS_PROGRAM_CURRENT, STATUS_PROGRAM.STATUS_PROGRAM_ON_HOLD],
      to: STATUS_PROGRAM.STATUS_PROGRAM_CANCELED,
    },
    {
      name: TRANSITION_PROGRAM.TRANSITION_PROGRAM_INACTIVE_NOTE, // cancel
      from: STATUS_PROGRAM.STATUS_PROGRAM_INACTIVE,
      to: STATUS_PROGRAM.STATUS_PROGRAM_INACTIVE,
    },
    {
      name: TRANSITION_PROGRAM.TRANSITION_PROGRAM_IS_CANCELED, // cancel
      from: STATUS_PROGRAM.STATUS_PROGRAM_CANCELED,
      to: STATUS_PROGRAM.STATUS_PROGRAM_CANCELED,
    },
  ],
  template: [
    {
      name: TRANSITION_PROGRAM.TRANSITION_PROGRAM_MARK_AS_READY, // mark as ready
      from: STATUS_PROGRAM.STATUS_PROGRAM_DRAFT,
      to: STATUS_PROGRAM.STATUS_PROGRAM_READY,
    },
    {
      name: TRANSITION_PROGRAM.TRANSITION_PROGRAM_MARK_AS_DRAFT, // mark as draft
      from: STATUS_PROGRAM.STATUS_PROGRAM_READY,
      to: STATUS_PROGRAM.STATUS_PROGRAM_DRAFT,
    },
  ],
};

export const ProgramStateMachine = (init, type) => {
  const transitions = transitionsByType[type];
  return new StateMachine({
    init,
    transitions,
  });
};



// WEBPACK FOOTER //
// ./src/state-machine/program/state-machine-program.js